/**
 * Plans v2 card 2.4: runs the plan-claim expiry check (plans/claimExpiry.js)
 * at start, on every auth change (sign-in, sign-out, offline ↔ online) and
 * once a minute, and returns its state for the desktop gate.
 */
import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { useClaimExpiryStore, checkClaimExpiry, CHECK_EVERY_MS } from '../plans/claimExpiry';

export function useClaimExpiry() {
  useEffect(() => {
    checkClaimExpiry();
    const unsubscribe = useAuthStore.subscribe((s, prev) => {
      if (s.isAuthenticated !== prev.isAuthenticated || s.isOffline !== prev.isOffline || s.user?.id !== prev.user?.id) {
        checkClaimExpiry();
      }
    });
    const timer = setInterval(() => checkClaimExpiry(), CHECK_EVERY_MS);
    return () => {
      unsubscribe();
      clearInterval(timer);
    };
  }, []);
  return useClaimExpiryStore((s) => s.state);
}

export default useClaimExpiry;
